<template>
  <div class="user-agreement-container">
    <iframe
      :src="agreementUrl"
      frameborder="0"
      class="agreement-iframe"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "UserAgreement",
  computed: {
    agreementUrl() {
      const locale = this.$i18n.locale;
      if (locale === 'ja' || locale === 'jp') {
        return '/userAgreement_ja.html';
      }
      return '/userAgreement.html';
    }
  }
};
</script>

<style lang="scss" scoped>
.user-agreement-container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.agreement-iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
